import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_FIELDS } from "../http-params.util";

/**
 * PermissionsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/permissionsApi/permissionsApi.service.js.
 *
 * Legacy uses `/v1/api/rbac/permissions` and rewrites `/v1/` → `/v2/` only
 * for `list()`. Preserved.
 */
const PERMISSIONS_BASE_V1 = "/v1/api/rbac/permissions";
const PERMISSIONS_BASE_V2 = "/v2/api/rbac/permissions";

@Injectable({ providedIn: "root" })
export class PermissionsApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(PERMISSIONS_BASE_V2, {
        params: buildParams(props, PAGINATION_FIELDS),
      }),
    );
  }

  detail(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>(`${PERMISSIONS_BASE_V1}/${id}`));
  }

  remove(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.delete<unknown>(`${PERMISSIONS_BASE_V1}/${id}`));
  }

  create(props: {
    name: string;
    displayName: string;
  }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.post<unknown>(PERMISSIONS_BASE_V1, {
        name: props.name,
        displayName: props.displayName,
      }),
    );
  }

  batchCreate(props: { mappings: unknown }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.post<unknown>(PERMISSIONS_BASE_V1, props.mappings),
    );
  }

  update(props: {
    id: number | string;
    name: string;
    displayName: string;
  }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(PERMISSIONS_BASE_V1, {
        id: props.id,
        name: props.name,
        displayName: props.displayName,
      }),
    );
  }
}
